interface HeroProps {
  onNewsletterClick: () => void;
}

export default function Hero({ onNewsletterClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/0fe0eea69dfb0ed5f21125c592cefc4e.png"
          alt="E.T.C REARVIEW Album Cover"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="mb-8">
          <h1 className="mb-4 flex justify-center">
            <img 
              src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/053272dcaa033b9b5356f9612e504e77.png"
              alt="E.T.C Logo"
              className="h-32 md:h-40 w-auto"
            />
          </h1>
          <p className="text-2xl md:text-3xl font-light tracking-widest text-red-500 mb-2">
            ERIC THE CENTAUR
          </p>
          <p className="text-lg md:text-xl text-gray-300 tracking-wide">
            REARVIEW
          </p>
        </div>

        <div className="mb-12">
          <p className="text-6xl md:text-7xl font-black text-red-600 mb-4">
            OUT NOW
          </p>
          <p className="text-3xl md:text-4xl font-light text-gray-200">
            STREAMING EVERYWHERE
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#music"
            className="px-10 py-4 bg-red-600 hover:bg-red-700 text-white font-bold text-lg tracking-wider transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            LISTEN NOW
          </a>
          <button
            onClick={onNewsletterClick}
            className="px-10 py-4 border-2 border-white hover:bg-white hover:text-black text-white font-bold text-lg tracking-wider transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            STAY UPDATED
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <i className="ri-arrow-down-line text-4xl text-red-500"></i>
      </div>
    </section>
  );
}
